import SavedReportList from "./SavedReportList";

export default SavedReportList;
